import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const StrikethroughIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.66666 15.3333C6.66666 17.9107 8.75599 20 11.3333 20H13.3158C15.5346 20 17.3333 18.2013 17.3333 15.9825C17.3333 14.3754 16.1438 12.6331 14.6667 12M10.1066 10.2362C8.82862 9.68846 7.99999 8.43181 7.99999 7.04137C7.99999 5.36167 9.36166 4 11.0414 4H12.6667C14.5076 4 16 5.49238 16 7.33333M4.66666 12H19.3333"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
